export default __webpack_public_path__ + "static/media/skills-outline-16px.ee623f97.svg";